import React from 'react'
import { Link } from 'gatsby'
import Tachyons from 'tachyons'
import Logo from '../images/new-logo.png'

const Header = ({ siteTitle }) => (
  <header className="w-100 bg-black ph1 ph2-m ph3-l">
    <nav className="db dt-l w-100 border-box pa3">
        <Link to="/"
          className="db dtc-l f5 f4-l fw6 v-mid white link dim w-100 w-30-l tc tl-l mb0-l"  style={{
            color: '#00a0aa'
          }}>
          <img src={Logo} className="h3 mb0-l v-mid" height="100%" alt="Riverton Community Arts Centre"/>
        </Link>
        <div className="ttu db dtc-l white f7 f6-l fw7 v-mid w-100 w-70-l tc tr-l">
          <Link className="link dim white dib mr3 mr4-l" to="/" title="Home">Home</Link>
          <Link className="link dim white dib mr3 mr4-l" to="/events-and-exhibitions/" title="Events">Events & Exhibitions</Link>
          <Link className="link dim white dib mr3 mr4-l" to="/friends-of-the-arts/" title="Friends of the Arts">Friends of the Arts</Link>
          {/* <Link className="link dim white dib mr3 mr4-l" to="/newsletter/" title="Newsletter">Newsletter</Link> */}
          <Link className="link dim white dib mr3 mr4-l" to="/artists/" title="Artists">Artists</Link>
          {/* <Link className="link dim white dib mr3 mr4-l" to="/riverton/" title="Riverton">Riverton</Link> */}
        </div>
    </nav>
  </header>
)

export default Header
